module.exports = __webpack_public_path__ + "assets/img/3.1259e6ea.png";